import React, { useRef, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { debounce } from 'lodash'; // lodash debounce for better performance
import { getProductsAutocompleteFromWarehouse } from 'actions/EntityActions';
import { formInput, clearFormInput } from 'actions/FormActions';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Button from 'screens/components/basic/Button';

const AutoCompleteBulkTransfer = ({ name, label, options: propsOptions, hintText, warehouseId, addProductToTransfer, minLength = 3, maxLength = 250 }) => {
  const dispatch = useDispatch();

  // Getting state from Redux store
  const { productsWarehouses } = useSelector((state) => state.entity) || [];
  const [options, setOptions] = useState([]);
  const [value, setValue] = useState("");
  const [searchText, setSearchText] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);

   // Refs
  //  const nameInput = useRef(null);

   useEffect(() => {
    if (productsWarehouses.list && productsWarehouses.list.length > 0) {
      const newOptions = productsWarehouses.list.map((item) => ({
        title: item.productName,
        text: item.productName,
        value: item.productId.toString(),
        product: item
      }));
      setOptions(newOptions); 
    }
  }, [productsWarehouses]);

  const getProducts = () => {
    if (!searchText) {
      alert('Please input search text!');
      return;
    } else {
      const model = {
        WarehouseId: warehouseId,
        ProductName: searchText
      }
      setSearchText('');
      setOptions([]); 
      setError('')
      dispatch(getProductsAutocompleteFromWarehouse(model));
      setOpen(true);
    }
  }

  const handleInputChange = (event, newInputValue) => {
    if (!newInputValue) { // need to aware when the component is loaded, the value is undefined
      setSearchText('');
      dispatch(clearFormInput(name));
      dispatch(clearFormInput(`${name}Text`));
    } else if (newInputValue.length < minLength && newInputValue.length > 0){
      setError(`The minimum length of this field is ${minLength}!`)
      setSearchText(newInputValue);
      dispatch(formInput(value, name));
    }else{
      setError('')
      setSearchText(newInputValue);
      dispatch(formInput(value, name));
    }
  };

  const onSelect = (chosenRequest) => {
    if (chosenRequest){
      updateStore(chosenRequest.id || chosenRequest.value, chosenRequest.text, chosenRequest.product || null);
    }
  }

  const updateStore = (value, text, product) =>{
    setValue(value);
    addProductToTransfer(product);
    setOpen(true);
    setError('');
  }

  return (
    <div className="form-group ProductSearchSelect mt-1 mb-1">
      <Autocomplete
        open={open}
        onClose={() => setOpen(false)}
        freeSolo
        openOnFocus={true}
        id={name}
        name={name}
        value={value}
        inputValue={searchText}
        options={options}
        getOptionLabel={options => options.title || ""}
        filterOptions={(options) => options.slice(0, 30)}
        onInputChange={handleInputChange}
        onChange={(event, value) => onSelect(value)}
        InputLabelProps={{ shrink: true }} 
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            error={Boolean(error)}
            helperText={error ? error : ""}
            variant="standard"
            placeholder={`${hintText}, please input at least 3 characters`}
            min={3}
            onClick={() => setOpen(prevOpen => !prevOpen)}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loading ? <span>Loading...</span> : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
      />
      <Button
          type="IconSearchButtonLabel"
          className="SearchBtn float-R mb-2 btnBlue"
          mini={true}
          label="Search Product"
          onTouchTap={getProducts}
        />
    </div>
  );
}

export default AutoCompleteBulkTransfer;